import { combineReducers } from 'redux';
import menu from './menu';
import auth from './auth';
import users from './users';
import patients from './patients';
import dashboard from './dashboard';
import script from './script';
import rightBar from './rightBar';
import team from './team';
import refills from './refills';
import loadingProgress from './loadingProgress';
import physicians from './physicians';
import products from './products';
import healths from './healths';
import possiblePersons from './possiblePersons';
import chat from './chat';

const rootReducer = combineReducers({
  chat,
  menu,
  auth,
  team,
  users,
  script,
  refills,
  healths,
  products,
  patients,
  rightBar,
  dashboard,
  physicians,
  possiblePersons,
  loadingProgress,
});

export default rootReducer;
